import { SvgIcon } from "@mui/material"
import React from "react"

interface IProps {
  sx?: any
}

export function IconQuestionnaire(props: Readonly<IProps>): React.JSX.Element {
  const { sx } = props

  return (
    <SvgIcon
      {...props}
      xmlns="https://fonts.google.com/"
      strokeWidth={2}
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
      stroke="currentColor"
      sx={{
        width: sx?.width ? sx?.width : "24",
        height: sx?.height ? sx?.height : "24",
      }}>
      <path
        d="M176-120q-19-4-35.5-20.5T120-176l664-664q21 5 36 20.5t21
       35.5L176-120Zm-56-252v-112l356-356h112L120-372Zm0-308v-80q0-33 
       23.5-56.5T200-840h80L120-680Zm720 92v112l-19 19q-20-10-42.5-15.5T732-480l108-108ZM372-120l108-108q2
        24 7.5 46.5T503-139l-19 19H372Zm308-80H560v-80h120v-120h80v120h120v80H760v120h-80v-120Z"
      />
    </SvgIcon>
  )
}
